import React from "react";
import { MRT_ColumnDef } from "material-react-table";
import { Box, Tooltip } from "@mui/material";

import { EsgSitesIcon, SitemultiRegion } from "assets";
import { isNullOrUndefined } from "utils";
import { EMPTY_CELL_VALUE } from "consts";

export const SITES_PAGE = {
  ABSOLUTE_PATH: "/sites",
  TITLE: "Site Management",
  SIDEBAR_TITLE: "Site Mgmt",
  ICON: <EsgSitesIcon />,
  IS_TBD: false,
  renderMenu: false,
};

export const siteDetailsColumns: MRT_ColumnDef<any>[] = [
  {
    accessorKey: "name",
    header: "Site Name",
    size: 60,
    Cell: ({ cell }: any) => {
      const value = cell.getValue() as string;

      if (!value) {
        return <Box sx={{ paddingLeft: "15px" }}>{EMPTY_CELL_VALUE}</Box>;
      }
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              maxWidth: "160px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "type",
    header: "Type of Site",
    size: 40,
  },
  {
    accessorKey: "businessUnit",
    header: "Business Unit",
    size: 40,
    Cell: ({ cell }: any) => {
      const value = cell.getValue() as string;
      if (!value) {
        return <Box sx={{ paddingLeft: "15px" }}>{EMPTY_CELL_VALUE}</Box>;
      }
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              maxWidth: "160px",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "city",
    header: "City",
    size: 100,
  },
  {
    accessorKey: "country",
    header: "Country",
    Cell: ({ cell }) => {
      const value = cell.getValue() as string;
      if (isNullOrUndefined(value)) {
        return EMPTY_CELL_VALUE;
      }
      return (
        <div>{value.replaceAll("_", " ")}</div>
      )
    },
    size: 40,
  },
  {
    accessorKey: "countryRegion",
    header: "Region",
    size: 40,
  },
  {
    accessorKey: "region",
    header: "Electricity Region Code",
    size: 240,
    Cell: ({ row }: any) => {
      const { multipleRegion: regionmultiple, region, customRegion } = row.original;

      let message = "";
      if (region === null && customRegion === null) {
        message = regionmultiple
          ? "Multiple region codes found"
          : "Missing region code";
      }

      return (
        <div
          style={{
            display: "flex",
          }}
        >
          {region === null && customRegion === null ? (
            <span style={{ color: "#D86262" }}>
              <SitemultiRegion
                style={{
                  marginRight: "2px",
                  paddingTop: regionmultiple ? "0px" : "4px",
                }}
              />
              {message}{" "}
            </span>
          ) : (
            <span>{customRegion || region}</span>
          )}
        </div>
      );
    },
  },
  {
    accessorKey: "address",
    header: "Street Address",
    size: 40,
    Cell: ({ cell }: any) => {
      const value = cell.getValue() as string;

      if (!value) {
        return <Box sx={{ paddingLeft: "15px" }}>{EMPTY_CELL_VALUE}</Box>;
      }
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              alignItems: "center",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "zipCode",
    header: "ZipCode",
    size: 40,
  },
  {
    accessorKey: "siteArea",
    header: "Site Area",
    size: 40,
    Cell: ({ cell }: any) => {
      const value = cell.getValue() as string;

      if (!value) {
        return <Box sx={{ paddingLeft: "15px" }}>{EMPTY_CELL_VALUE}</Box>;
      }
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              alignItems: "center",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "siteAreaUnit",
    header: "Site Area Unit",
    size: 40,
    Cell: ({ cell }: any) => {
      const value = cell.getValue() as string;

      if (!value) {
        return <Box sx={{ paddingLeft: "15px" }}>{EMPTY_CELL_VALUE}</Box>;
      }
      return (
        <Tooltip title={value}>
          <Box
            sx={{
              alignItems: "center",
              textOverflow: "ellipsis",
              whiteSpace: "nowrap",
              overflow: "hidden",
            }}
          >
            {value}
          </Box>
        </Tooltip>
      );
    },
  },
  {
    accessorKey: "notes",
    header: "Notes",
    size: 40,
  },
];

export const SITE_COLUMN_ID_MAP: { [key: string]: string } = {
  customerSiteId: 'customerSiteId',
  name: 'name',
  type: 'type',
  businessUnit: 'businessUnit',
  city: 'city',
  country: 'country',
  countryRegion: 'countryRegion',
  userName: 'userName',
  status: 'status',
};

export const SITE_COLUMN_ID_MAP_DISPLAY_NAME: { [key: string]: string } = {
  customerSiteId: 'Customer Site ID',
  name: 'Site Name',
  type: 'Type of Site',
  businessUnit: 'Business Unit',
  city: 'City',
  country: 'Country',
  countryRegion: 'Region',
  userName: 'Data Provider',
  status: 'Status',
};

export const SITES_REQUIRED_FIELDS = Object.keys(SITE_COLUMN_ID_MAP);
